<template>
  <div id="energy-scenario-edit-view">

    <div class="vx-col w-full mb-base">
      <vx-card ref="infoCard" :title="cardTitle" title-color="black">

          <vs-tabs v-model="selectedTab" :key="tabsKey">
            <vs-tab value="0" :label="$t('Decarbonization.EnergyScenarios.BaseInfoTab')" icon-pack="feather" icon="icon-file-text" style="min-height:400px">
              <ValidationObserver ref="observer">
                <vs-row class="mt-5">
                  <vs-col vs-w="4" >
                    <vs-row class="mb-3">
                        <vs-col vs-w="12">
                          <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.Name')" rules="required" v-slot="{ errors }">
                            <validated-input
                              :label="$t('Decarbonization.EnergyScenarios.Name')"
                              v-model="name"
                            ></validated-input>
                            <validation-message>{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                      </vs-row>
                      <vs-row class="mb-3">
                        <vs-col vs-w="12">
                          <ValidationProvider :name="$t('Decarbonization.EnergyScenarios.Compilation')" rules="required" v-slot="{ errors }">
                            <form-label>{{$t('Decarbonization.EnergyScenarios.Compilation')}}</form-label>
                            <v-select
                              :options="availableCompilations"
                              label="name"
                              :reduce="x => x.id"
                              v-model="compilationId"
                              class="w-full"
                              name="energySourceId"
                            />
                            <validation-message>{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                   <vs-col class="mt-5" vs-w="8">
                    <vs-row vs-type="flex" vs-justify="flex-end">
                      <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
                          <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="saveData">{{ $t('Save') }}</vs-button>
                          <vs-button type="border" class="mr-3" color="danger" @click="returnToList">{{ $t('Cancel') }}</vs-button>
                      </vs-col>
                    </vs-row>
                  </vs-col>
                </vs-row>
              </ValidationObserver>
            </vs-tab>
            
            <vs-tab value="1" :label="$t('Decarbonization.EnergyScenarios.LOMParametersTab')" icon-pack="feather" icon="icon-settings" v-if="id!=0">
              <Parameters v-model="parameterInfo" @openLOMEditionTab="openLOMEditionTab"/>
            </vs-tab>

            <vs-tab value="2" :label="lomParameterEditTabTitle" icon-pack="feather" icon="icon-edit" v-if="showLOMEditionTab" style="min-height:400px" >
              <ParameterEdition v-model="parameterEditionInfo" @cancelLOMEdit="cancelLOMEdit"/>
            </vs-tab>
          </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>

import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "@/app/shared/components";

import vSelect from 'vue-select';
import Parameters from './components/Parameters.vue';
import ParameterEdition from './components/ParameterEdition.vue';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormLabel,
    ValidatedInput,
    ValidationMessage,
    vSelect,
    Parameters,
    ParameterEdition
  },
  data() {
    return {
      id: 0,
      name : '',
      compilationId: '',
      availableCompilations: [],
      parameters: [],
      parametersToCreate: [],
      selectedTab: 0,
      showLOMEditionTab: false,
      tabsKey: 0,

      // v-model for the Parameters component
      parameterInfo: {
        parameters: [],
        parametersToCreate: []
      },

      // v-model for the ParameterInfo component
      parameterEditionInfo: {
        selectedParameter: {},
        createNew: false,
        energyScenarioId: ''
      }
    };
  },
  watch: {
    selectedTab(newValue) {
      if (newValue !== 2) {
        this.showLOMEditionTab = false;
        this.forceTabsRefresh();
      }
      if (newValue === 1) {
        this.refreshModel();
      }
    }
  },
  computed: {
    cardTitle()  {
      if (this.id !== null && this.id > 0)
        return this.name;
      else
        return this.$t('Decarbonization.EnergyScenarios.AddNew');
    },
    lomParameterEditTabTitle() {
      if (this.parameterEditionInfo.selectedParameter) {
        return this.parameterEditionInfo.selectedParameter.displayName + ' - ' + this.$t('Decarbonization.EnergyScenarios.LOMParametersEditionTab');
      }
      return this.$t('Decarbonization.EnergyScenarios.LOMParametersEditionTab');
    }
  },
  created() {
    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.id = this.$route.params.editData.id;   
    }
    
    this.initializeForm();
  },

  methods: {
    initializeForm() {
      this.$vs.loading();
      Promise.all([
        this.fetchCompilations(),
        this.fetchModel()
      ]).finally(() => {
        this.$vs.loading.close();
      })
    },
    fetchCompilations() {
      return new Promise((resolve, reject) => {
        this.$cqrsGet("cashflow/decarbonization/LomCompilations/findall/")
          .then((response) => {
            this.availableCompilations = response.data.model.map(x => ({
              id: x.id,
              name: x.name,
              description: x.description,
              createdBy: x.createdBy,
              creationDate: x.creationDate
            }));
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fetchModel() {
      return new Promise((resolve, reject) => {
        if (this.id === null || this.id <= 0) {
          resolve();
        }
        else {
          this.$cqrsGet("cashflow/decarbonization/energyScenarios/find/", { params : { id: this.id }})
            .then((response) => {
              this.name = response.data.model.name;
              this.compilationId = response.data.model.compilationId;
              this.parameterInfo.parameters = response.data.model.parameters;
              this.parameterInfo.parametersToCreate = response.data.model.parametersToCreate;
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        }
      })
    },
    refreshModel() {
      this.$vs.loading();
      this.fetchModel().finally(() => this.$vs.loading.close());
    },
    saveData() {
      this.$refs.observer.validate().then(result => {
        if (!result) return;
        
        this.$vs.loading();
        const energyScenario = {
          id: this.id,
          name: this.name,
          compilationId: this.compilationId
        };

        const url = (this.id !== null && this.id > 0) ? 'cashflow/decarbonization/energyScenarios/edit' : 'cashflow/decarbonization/energyScenarios/create';
        this.$cqrsPost(url, { energyScenario })
          .then((response) => {
            const model = response.data.model;
            this.id = model.id;
            this.parameterInfo.parameters = response.data.model.parameters;
            this.parameterInfo.parametersToCreate = response.data.model.parametersToCreate;
            this.$notifySaveSuccess();
          })
          .finally(() => {
            this.selectedTab = 1;
            this.forceTabsRefresh();
            this.$vs.loading.close();
          })
      });
    },
    returnToList() {
      this.$router.push({ name: 'BSG-decarbonization-energyScenarios'});
    },
    forceTabsRefresh() {
      // This is a hack
      // (turns out when you use dynamic v-ifs with vs-tabs you need to force their reload....)
      // https://michaelnthiessen.com/force-re-render/
      this.tabsKey++;
    },
    openLOMEditionTab(evt) {
      this.parameterEditionInfo.selectedParameter = evt.parameter;
      this.parameterEditionInfo.createNew = evt.createNew;
      this.parameterEditionInfo.energyScenarioId = this.id;

      this.showLOMEditionTab = true;
      this.$nextTick(() => {
        this.selectedTab = 2;
        this.forceTabsRefresh();
      });
      
    },
    cancelLOMEdit() {
      this.showLOMEditionTab = false;
      this.$nextTick(() => {
        this.selectedTab = 1;
        this.forceTabsRefresh();
      });
    }
  }
};
</script>